export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const TOGGLEDARK = "TOGGLEDARK";